// extracted by mini-css-extract-plugin
export default {"container":"circular-progress_container__j+Nfu","inProgress":"circular-progress_inProgress__r+u1F","text":"circular-progress_text__yUV7c"};